// project import
import pages from './pages';
import SamplePage from './sample-page';
import configuracao from './configuracao';
import controles from './controles';
import projetos from './projetos';
import normativos from './normativos';
import planos from './planosAcao';
import pages2 from './pages2';
import perfilEsg from './esg';
import configuracoes from './configuracoes';
// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
  items: [ pages2, pages, configuracao, controles, projetos, normativos, planos, perfilEsg, SamplePage, configuracoes]
};

export default menuItems;
